
import ionic1 from "../Images/ionic.png"
import ionic2 from "../Images/ionic(1).png"

const ionicData = [
    {
        id: 1,
        src: ionic1,
        title: "Fitbit Ionic",
        price: "$249.95"
    },
    {
        id: 2,
        src: ionic2,
        title: "Fitbit Ionic: adidas edition",
        price: "$279.95"
    }

]

export default ionicData